import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone.js'
import utc from 'dayjs/plugin/utc.js'
import type { PromotionResponseSchema } from './schemas'
import { PromotionType } from './types'

dayjs.extend(utc)
dayjs.extend(timezone)

export type PromotionStatus = 'active' | 'disabled' | 'expired' | 'awaiting-activation' | 'max-uses-exceeded' | 'deleted'

function inPromotionTz(input: Date | string, tz: string) {
  return dayjs(input).tz(tz)
}

export function getPromotionStatus(promotion: PromotionResponseSchema, now: Date = new Date()): PromotionStatus {
  if (promotion.deletedAt) {
    return 'deleted'
  }

  if (promotion.disabledAt) {
    return 'disabled'
  }

  if (promotion.activeAt && inPromotionTz(now, promotion.timezone).isBefore(inPromotionTz(promotion.activeAt, promotion.timezone))) {
    return 'awaiting-activation'
  }

  if (promotion.expireAt && inPromotionTz(now, promotion.timezone).isAfter(inPromotionTz(promotion.expireAt, promotion.timezone))) {
    return 'expired'
  }

  const promotionUses = promotion.users?.length ?? 0
  if (promotion.maxUses && promotionUses >= promotion.maxUses) {
    return 'max-uses-exceeded'
  }

  return 'active'
}

/**
 * Referral records are only kept for referral links and promotions owned by a referrer (e.g. RAF and partner coupons).
 * A generic coupon such as HEALTHY3030 records its discount only.
 */
export function isReferralTracked({ type, referrerUserId }: { type: PromotionType, referrerUserId?: string | null }): boolean {
  return type === PromotionType.REFERRAL || !!referrerUserId
}
